import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import CardMapping from "../../../helpers/card-mapping"
import CopyContainer from "../../atoms/copy-container"
import Grid from "../../atoms/grid"
import Heading from "../../atoms/heading"
import Card from "../../molecules/card"

const Collection = ({ title, description, collection, color, feature }) => {
  const { site, allSanityDictionary, allSanityCountry } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            siteUrl
          }
        }
        allSanityCountry {
          nodes {
            url
            abbreviation
          }
        }
        allSanityDictionary {
          nodes {
            key {
              current
            }
            value
          }
        }
      }
    `
  )

  const country = allSanityCountry.nodes.find(
    (c) => c.url === site.siteMetadata.siteUrl
  ).abbreviation

  const regionCollection = collection.filter(
    (c) => c.country?.abbreviation === country || !c.country
  )

  if (regionCollection.length > 0) {
    let primary = null
    let rest = regionCollection
    if (feature && regionCollection.length !== 2) {
      primary = regionCollection.slice(0, 1)
      rest = regionCollection.length > 1 ? regionCollection.slice(1) : null
    }

    return (
      <>
        <Heading>{title}</Heading>
        <CopyContainer content={description} />
        {primary ? (
          <Card
            article={CardMapping(primary[0], allSanityDictionary.nodes)}
            variant="primary_feature"
            color={color}
          />
        ) : (
          ""
        )}
        {rest ? (
          <Grid col={Math.min(3, rest.length)}>
            {rest.map((card) => (
              <div>
                <Card
                  article={CardMapping(card, allSanityDictionary.nodes)}
                  variant="labelled"
                />
              </div>
            ))}
          </Grid>
        ) : (
          ""
        )}
      </>
    )
  }
  return ""
}

export default Collection

Collection.propTypes = {
  title: PropTypes.string,
  collection: PropTypes.array,
  description: PropTypes.object,
  color: PropTypes.string,
  feature: PropTypes.bool,
}

Collection.defaultProps = {
  title: "",
  description: null,
  collection: [],
  color: "",
  feature: false,
}
